import React, { useEffect, useState } from 'react';
import { APP_CONST } from '../../constants';
import { 
    GeckoAlert, 
    Spinner, 
    ProfileList
} from '../../components';
import { Auth } from '../../services';
import ErrorTracker from '../../services/ErrorTracker';

const ProfileSelector = ({client, app, onSelectProfile, autoRedirect = true, onError = () => {}}) => {
    const [profiles, setProfiles] = useState(null);
    const [apps, setApps] = useState(null);
    const [accounts, setAccounts] = useState(null);

    useEffect(() => {
        getProfiles(client, app).then(({accounts, apps, profiles}) => {
            if (profiles.length === 1 && autoRedirect === true && !accounts.all[0].IsClosed) {
                return onSelectProfile(profiles[0]);
            } 

            setProfiles(profiles);
            setApps(apps);
            setAccounts(accounts);
        }).catch((err) => {
            onError(err);
        });
    }, []);

    if (!profiles || !apps || !accounts) {
        return <LoadingProfiles />
    }

    return(
        <div id="profiles">
            <ProfileList 
                profiles={profiles} 
                apps={apps.byId} 
                accounts={accounts.byId} 
                onClick={(profile) => onSelectProfile(profile)} 
            />
        </div>
    );
};

/**
 * 
 * @returns {Promise<any>}
 */
const getProfiles = (client = null, app = null) => {
    return Auth.saturate(client, app).then((data) => {
        if (data.profiles.length === 0) {
            throw new Error('No Profiles for your account found');
        }

        return data;
    }).catch((err) => {
        ErrorTracker.captureException(err);
        throw err;
    });
}

const LoadingProfiles = () => {
    return (
        <div className="row text mt-3 mb-3">
            <div className="col d-flex flex-column align-items-center">
                <Spinner size="small" color="blue" />
            </div>
        </div>
    );
}

export default ProfileSelector;
